import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
import { isValidUrl } from "./../../../utils/functions";

const HomeTile = ({
  imageid = null,
  link = '#',
  title = 'Tuile sans titre',
  keywords = 'Mots-clés manquants',
  images = [],
  placeholder = false,
  blank = false
}) => {
  // Vérification que images est un tableau
  const safeImages = Array.isArray(images) ? images : []

  const img =
    imageid &&
    imageid !== 0 &&
    safeImages &&
    safeImages.find(({ wordpress_id }) => wordpress_id === imageid);
  const imageSharpSizes =
    img &&
    img.localFile &&
    img.localFile.childImageSharp &&
    img.localFile.childImageSharp.sizes;

  if (placeholder) {
    return (
      <div className="tiles-list-item">
        <div className="placeholder">
          <div className="img-wrapper" />
          <div className="h3" />
          <span />
        </div>
      </div>
    );
  }

  if (blank || isValidUrl(link)) {
    return (
      <div className="tiles-list-item">
        <a href={link} target="_blank" rel="noopener noreferrer" aria-label={`${title} (s'ouvre dans un nouvel onglet)`}>
          <div className="img-wrapper">
            {imageSharpSizes && <Img sizes={imageSharpSizes} alt={title} />}
          </div>
          <h2 className="h3-like">{title}</h2>
          <span>{keywords}</span>
        </a>
      </div>
    );
  }

  return (
    <div className="tiles-list-item">
      <Link to={link}>
        <div className="img-wrapper">
          {imageSharpSizes && <Img sizes={imageSharpSizes} alt={title} />}
        </div>
        <h2 className="h3-like">{title}</h2>
        <span>{keywords}</span>
      </Link>
    </div>
  );
};

export default HomeTile;
